<template>
  <v-dialog v-model="dialog" width="600px" persistent>
    <v-form @submit.prevent="handleSubmit()">
      <v-card :disabled="loading">
        <v-card-title>
          Atualizar Produto
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="form.nome"
            label="Nome"
            :error-messages="validationErrors.nome"
            autofocus
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close()" text>Cancelar</v-btn>
          <v-btn color="primary" type="submit" :loading="loading">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import api from "@/services/locacoes.js";
import alerts from "@/mixins/alerts.js";

export default {
  mixins: [alerts],

  data() {
    return {
      dialog: false,
      loading: false,
      form: {
        id: null,
        nome: ""
      },
      validationErrors: {}
    };
  },

  methods: {
    open(produto) {
      this.reset(produto);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    reset(produto) {
      this.form = {
        ...produto
      };

      this.validationErrors = {};
    },

    async handleSubmit() {
      this.validationErrors = {};
      this.loading = true;

      try {
        const product = await api.products.update(this.form.id, this.form);
        this.$emit("updated", product);
        this.close();
      } catch (error) {
        if (error.response.status === 422) {
          this.validationErrors = error.response.data.errors;
          this.error("Corrija o formulário e tente novamente");
          return;
        }

        this.error("Não foi possível cadastrar produto");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
